import React from "react";

const Timber = () => {
  return (
    <>
      <section id="about-us" className="py-2">
      <div className="container">
        <div className="two-card-container">
          <article className="card">
          <h2>Timber</h2>
            <p>
            Timber flooring offers timeless elegance and natural beauty that can enhance the overall aesthetic of any space. The unique grain patterns and warm tones of timber create a sense of warmth and sophistication, adding a touch of luxury to your home. With timber flooring, you can enjoy the natural beauty of wood that never goes out of style.
            </p>
            <br />
            <p>
            One of the key advantages of timber flooring is its durability. High-quality timber can withstand heavy foot traffic and resist scratches, dents, and stains, making it an excellent long-term investment. With proper care and maintenance, timber flooring can last for decades, retaining its beauty and value over time.
            </p>
            <br />
            <p>
            Timber flooring provides excellent insulation properties, helping to regulate temperature and reduce energy consumption. Wood has natural insulating qualities that help keep your space warmer in the winter and cooler in the summer. By choosing timber flooring, you can create a more energy-efficient home and potentially reduce heating and cooling costs.
            </p>
            <br />
          </article>
          <article className="card">
            <div className="director-photo">
            <img
                src={
                  "../Images/articles/timber_main.jpg"
                }
                alt="Timber"
                className="article-img"
              />
            </div>
          </article>
        </div>
      </div>
    </section>
    </>
  );
};

export default Timber;
